module.exports = __webpack_public_path__ + "static/img/prohibido.9a26027.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/prohibido.png
// module id = k5/6
// module chunks = 1